module.exports = __webpack_public_path__ + "static/media/undraw_programming_re_kg9v.a7ebf78a.svg";